import { Injectable } from '@angular/core';
import { DocumentModel } from '../models/document.model';
import { ApiService } from './api.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { AnswerModel } from '../models/answer.model';

@Injectable()
export class PdfDocumentService {
  private _document$ = new BehaviorSubject<DocumentModel | null>(null);
  private _documentDisconnectedFromTXdocsAnswerPoolSubject = new BehaviorSubject<boolean>(false);

  constructor(private apiService: ApiService) {}

  get documentDisconnectedFromTXdocsAnswerPool$() {
    return this._documentDisconnectedFromTXdocsAnswerPoolSubject.asObservable();
  }

  get documentDisconnectedFromTXdocsAnswerPool(): boolean {
    return this._documentDisconnectedFromTXdocsAnswerPoolSubject.value;
  }

  get document$(): Observable<DocumentModel | null> {
    return this._document$;
  }

  getDocument(model: DocumentModel): Observable<any> {
    return this.apiService.post<DocumentModel>('pdfdocument/get', model, {
      showToast: true,
    });
  }

  getDocumentBySession(model: DocumentModel): Observable<any> {
    return this.apiService.post('pdfdocument/getdocumentbysession', model, {
      showToast: true,
    });
  }

  saveDocument(model: DocumentModel): Observable<any> {
    return this.apiService.post('pdfdocument/save', model, {
      showToast: true,
    });
  }

  openDocumentInNewSession(model: DocumentModel): Observable<any> {
    return this.apiService.post<DocumentModel>('pdfdocument/opendocumentinnewsession', model, {
      showToast: true,
    });
  }

  getAnswersFromPool(document: DocumentModel) {
    return this.apiService.post('pdfdocument/getanswers', document, { showToast: false });
  }

  saveAnswersToPool(answers: Array<AnswerModel>) {
    return this.apiService.post('pdfdocument/saveanswers', { answers: answers }, { showToast: false });
  }

  documentWasLoaded(model: DocumentModel) {
    this._document$.next(model);
  }

  setDocumentDisconnected(value: boolean) {
    this._documentDisconnectedFromTXdocsAnswerPoolSubject.next(value);
  }

}
